import QuestionPage from './QuestionPage';

export default QuestionPage;
